import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/ad65d83c1087407616f0591309583e77/5910930edf8f8435ab6c0a56926fd219.png" 
                alt="DBD Podcast Logo" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              Where business wisdom meets the art of distillation. Deep conversations about entrepreneurship, 
              leadership, and industry expertise.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                <i className="ri-spotify-fill text-2xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                <i className="ri-apple-fill text-2xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                <i className="ri-google-fill text-2xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-2xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-2xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/episodes" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Episodes
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  About
                </Link>
              </li>
              <li>
                <Link to="/subscribe" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Subscribe
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Partners */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Partners</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://aliassmith.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  AliasSmith
                </a>
              </li>
              <li>
                <a 
                  href="https://jumpify.net" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Jumpify.net
                </a>
              </li>
              <li>
                <a 
                  href="https://loschapulines.org" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Los Chapulines
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm mb-4 sm:mb-0">
              © 2024 DBD Podcast. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link to="/privacy" className="text-gray-500 hover:text-white transition-colors cursor-pointer">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-500 hover:text-white transition-colors cursor-pointer">
                Terms of Service
              </Link>
              <Link to="/contact" className="text-gray-500 hover:text-white transition-colors cursor-pointer">
                Contact
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
